import Handorgel from "handorgel";
const acc = document.querySelector(".acc");

if (acc) {
    const accordion = new Handorgel(document.querySelector(".acc"), {
        multiSelectable: false,
        // header/content class if fold is open
        headerOpenClass: "acc__header--open",
        contentOpenClass: "acc__content--open",

        // header/content class if fold has been opened (transition finished)
        headerOpenedClass: "acc__header--opened",
        contentOpenedClass: "acc__content--opened",

        // header/content class if fold has been focused
        headerFocusClass: "acc__header--focus",
        contentFocusClass: "acc__content--focus",

        // header/content class if fold is disabled
        headerDisabledClass: "acc__header--disabled",
        contentDisabledClass: "acc__content--disabled",
    });

    accordion.on("fold:close", (fold) => {
        fold.header.classList.add("acc__header--close");
    });
    accordion.on("fold:closed", (fold) => {
        fold.header.classList.remove("acc__header--close");
    });
    accordion.on("fold:open", (fold) => {
        fold.header.classList.remove("acc__header--close");
    });
}
